export default {

    newScope: 'Nuevo Alcance',
    areasProcess: 'Áreas y procesos organizacionales ',
    noAreasProcesses: 'Procesos organizacionales no encontrados',
    noAreaProcess: 'Proceso organizacional no encontrado',
    ubication: 'Ubicación',
    interestedParties: 'Partes interesadas',
    notes: 'Notas',
    createScope: 'Crear Alcance',
    editScope: 'Editar Alcance',
    getScopeError: 'Error al obtener alcance',
    editScopeError: 'Ha un ocurrido un error al editar el alcance',
    createScopeError: 'Ha un ocurrido un error al crear el alcance',
    editScopeSuccess: 'Alcance editado exitosamente',
    createScopeSuccess: 'Alcance creado exitosamente',
    systemConfigurationPlaceHolder: 'Parametrización del sistema',
    interestedPartiesPlaceHolder: 'Partes interesadas... 0/500',
    notesPlaceHolder: 'Notas 0/500',
    descriptionPlaceHolder: 'Descripción 0/500',
    scopes: 'Alcances',
    scope: 'Alcance',
    status: 'Estado',
    oneScope: 'Un',
    getScopesError: 'Ha ocurrido un error al obtener los alcances: ',
    deleteScopeError: 'Ha ocurrido un error al eliminar el alcance: ',
    deleteScopeSuccess: 'Alcance eliminado exitosamente',
    scopeDetail: 'Ver detalle de alcance',
    editScopeLoader: 'Editando alcance...',
    createScopeLoader: 'Creando alcance...',
    deleteLoader: 'Eliminando alcance...',
    selectScope: 'Selecciona un alcance para continuar',
    whatIsScope: '¿Qué es un alcance?',
    scopeGuide: 'permite definir los límites de tu análisis de riesgo, esto es ¿A qué se le va a realizar un análisis de riesgos?. En esta interfaz puedes crear tu primer alcance de gestión de riesgos, después iremos a la creación de impactos.',
    scopeExampleSecurity: 'Seguridad de Infraestructura Tecnológica',
    scopeExampleSensibleData: 'Protección de Datos Sensibles',
    scopeExampleWebSecurity: 'Evaluación de Riesgos en Aplicaciones Web',
    scopeExamples: 'Ejemplos:',
    ScopeNoEliminable: 'Este alcance no puede ser eliminado, debes cambiar de alcance primero',
    endDate: 'Fecha de fin:',
    createFirstCope: 'Quiero crear mi primer alcance de análisis de riesgos',
    welcomeToScopesSection: '¡Bienvenido a la sección de Alcances!',
    defineFirstScopeMessage: 'Nos alegra que estés aquí. Antes de comenzar, define tu primer alcance para gestionar los riesgos de seguridad de la información de manera efectiva.',
    createNewOrganizationalProcess: 'Crear nuevo proceso organizacional',
    areasProcessesTooltip: 'Seleccione uno o más procesos organizacionales. Este campo es obligatorio.',
    interestedPartiesTooltip: 'Internos y externos (Empleados, Accionistas, propietarios y alta dirección, Agencias gubernamentales con autoridad regulatoria, Clientes, Proveedores, Socios y contratistas)',
    validityStartDate: 'Inicio de Vigencia:',
    validityEndDate: 'Fin de Vigencia:',
    saveScope: 'Guardar alcance'
};